import * as Sentry from '@sentry/react';
import { call } from 'redux-saga/effects';
import { eventBus, ReceiveMessageType } from 'utils/eventBus';

export function* reportCommandFailureSaga(error: unknown, command: ReceiveMessageType) {
  yield call(Sentry.captureException, error);
  yield call(eventBus.error, {
    name: 'command-failed',
    message: `Failed to process SDK command "${command}"`,
    data: { command },
  });
}
